export default __webpack_public_path__ + "static/media/tro_giup_co_dong.1060e3d4.png";